import axios from "axios";
import { API_URL } from "../../config/apiUrl";

const CustomAxiosInstance = () => {
  const axiosInstance = axios.create();

  axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (!error.response) {
        // window.location.href = "/connection-error";
      }
      return Promise.reject(error);
    }
  );

  axiosInstance.defaults.baseURL = API_URL;

  return axiosInstance;
};

export default CustomAxiosInstance;
